<template>
	<div>
		<vueSelect
			:searchable="false"
			:options="data.values"
			:placeholder="transformedLabel"
			v-model="data.currentValue"
		/>
	</div>
</template>

<script>
import vueSelect from 'vue-select'

export default {
	props: ['data'],
	name: "AspectTableSortingSingle",
	components: {
		vueSelect
	},
	computed: {
		transformedLabel() {
			const result = this.data.label.replace( '_', " " );
			return result.charAt(0).toUpperCase() + result.slice(1)
		}
	}
}
</script>

<style scoped>

.v-select.vs--single.vs--unsearchable {
	border: 1px solid #eee;
}

</style>